import { CustomButtonProps } from "../../interfaces/interface";

const Button = ({
  label = "",
  buttonClass,
  loading = false,
  type = "button",
  disabled = false,
  children,
  onClick,
}: CustomButtonProps) => {
  return (
    <button
      className={`button ${buttonClass}`}
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {children}
      {label}
      {loading && (
        <div className="button__loader flex">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
    </button>
  );
};

export default Button;